import {
    INTERVIEW_LIST_DATA,
    INTERVIEW_TABLE_DATA ,
    LOAD_TABLE_START ,
    LOAD_TABLE_DONE,
    CANCELINTERVIEW_TABLE_DATA,
    SEARCH_TABLE_DATA,
    SHOW_INTERVIEW_MODAL,
    HIDE_INTERVIEW_MODAL
    } from 'constants/interview';
    // 打印初始状态
    // 每次 state 更新时，打印日志
    // 注意 subscribe() 返回一个函数用来注销监听器
    const initialState = {
        isLoading:false,
        isLoadingList:false,
        // 存放table的数据列表
        interviewList:[],
        searchData:[],
        isLoadingInfo: false,
        interview:{
            visable:false
        }
    };
    export default function interview(state = initialState,actions){
          console.log(state,actions)
        switch(actions.type){
            case LOAD_TABLE_START:
                return {...state,isLoading:true};
            case LOAD_TABLE_DONE:
                return {...state,isLoading:false};
            case INTERVIEW_LIST_DATA:
                return {...state,interviewList:actions.interviewList};
            case INTERVIEW_TABLE_DATA:
                return {...state,interviewData:actions.interviewData};
            case CANCELINTERVIEW_TABLE_DATA:
                return {...state,interviewData:actions.interviewData};
            case HIDE_INTERVIEW_MODAL:
                    return {...state,interview:{...state.interview,visable:false}};
            case SHOW_INTERVIEW_MODAL:
                    return {...state,interview:{...state.interview,visable:true}};
            case SEARCH_TABLE_DATA:
                return {...state,searchData:actions.searchData};
            default:
                return state;
        }
    } 


// WEBPACK FOOTER //
// ./src/reducer/interview.js